import { createElement } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { REVIEWS_MY_REVIEWS } from 'utils/consts/path'
import { menuItems } from './useMenuItems'

const EDIT_OFFER_REGEX = /\/offer.*\/edit/
const PRICE_HISTORY_REGEX = /^\/acc\/([^/]+)\/price-history$/
const ADMIN_PRICE_HISTORY_REGEX =
  /\/acc\/administration\/retail-offers\/.*\/price-history/

export const useChapterIcon = icon => {
  const location = useLocation()
  const pathname = location.pathname

  if (icon) return icon

  const chapter = Object.values(menuItems).find(item => {
    return matchPath({ path: item.link, caseSensitive: false }, pathname)
  })

  if (chapter?.icon) return chapter?.icon

  if (
    pathname.startsWith('/acc/sell-wine') ||
    EDIT_OFFER_REGEX.test(pathname) ||
    pathname.startsWith('/acc/offer/create')
  ) {
    return menuItems.sellWine.icon
  } else if (pathname.startsWith('/acc/buy-wine')) {
    return menuItems.buyWine.icon
  } else if (pathname.startsWith('/acc/user/')) {
    return menuItems.account.icon
  } else if (
    pathname.startsWith('/acc/my-company') ||
    pathname.startsWith('/acc/company')
  ) {
    return menuItems.myCompany.icon
  } else if (
    pathname.startsWith('/acc/my-wines') ||
    pathname.startsWith('/acc/elabel') ||
    pathname.startsWith('/acc/captured-wines') ||
    pathname.startsWith('/acc/captured-wine')
  ) {
    return menuItems.capturedWines.icon
  } else if (
    pathname.startsWith('/acc/database') ||
    pathname.startsWith('/acc/product') ||
    pathname.startsWith('/acc/brand') ||
    pathname.startsWith('/acc/producer') ||
    pathname.startsWith('/acc/wine')
  ) {
    return menuItems.databasePerson.icon
  } else if (
    pathname.startsWith(REVIEWS_MY_REVIEWS) ||
    pathname.startsWith('/acc/review')
  ) {
    return menuItems.databaseManage.icon
  } else if (
    pathname.startsWith('/acc/administration') ||
    pathname.startsWith('/acc/images') ||
    pathname.startsWith('/acc/retail-offer/') ||
    pathname.startsWith('/acc/e-shop/')
  ) {
    return menuItems.administrationManage.icon
  } else if (pathname === '/acc' || pathname === '/acc/home-page') {
    return menuItems.homepage.icon
  } else if (
    PRICE_HISTORY_REGEX.test(pathname) ||
    pathname.startsWith('/acc/retail/')
  ) {
    return menuItems.retail.icon
  } else if (ADMIN_PRICE_HISTORY_REGEX.test(pathname)) {
    return menuItems.administrationManage.icon
  } else if (pathname.startsWith('/acc/e-labels')) {
    return menuItems.eLables.icon
  }

  return () => createElement('div')
}
